import {Component, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card';
import {HeadlineTextComponent} from "../../../shared/components/headline-text/headline-text.component";
import {DatePipe, NgIf, NgOptimizedImage} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {PreventDoubleClickDirective} from "../../../shared/directives/prevent-doublic-click-directive";
import {EmbedModeService} from "../../services/embed-mode.service";
import {CommentModel} from "../../../core/models/comment.model";
import * as moment from "moment-timezone";
import {ViessmannHomeBannerComponent} from "../../components/viessmann-home-banner/viessmann-home-banner.component";
import {AppointmentModel} from "../../../core/models/appointment.model";
import {ActivatedRoute} from "@angular/router";
import {SettingsModel} from "../../../core/models/settings.model";
import {
  ButtonHeatingSystemsOverviewComponent
} from "../../components/button-heating-systems-overview/button-heating-systems-overview.component";

@Component({
  selector: 'message-received',
  templateUrl: './message-received.component.html',
  styleUrls: ['./message-received.component.scss'],
  standalone: true,
  imports: [MatCard, TranslateModule, HeadlineTextComponent, DatePipe, MatCardContent, NgIf, NgOptimizedImage, MatButton, MatCardActions, PreventDoubleClickDirective, ViessmannHomeBannerComponent, ButtonHeatingSystemsOverviewComponent]
})
export class MessageReceivedComponent implements OnInit {

  public appointment!: AppointmentModel;
  public settings!: SettingsModel;
  public embedModeEnabled: boolean = false;
  public comment!: CommentModel;
  public locale!: string;
  public timezone!: string;

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private embedModeService: EmbedModeService) {
  }

  ngOnInit() {
    this.appointment = this.route.snapshot.data['appointment'];
    this.settings = this.route.snapshot.data['settings'];
    this.locale = this.translateService.currentLang;
    this.timezone = moment.tz.guess();
    this.embedModeEnabled = this.embedModeService.isEmbedModeEnabled();
    this.comment = history.state;
  }

  closeFrameEvent() {
    this.embedModeService.closeFrameEvent();
  }

}
